import { gql } from 'src/generated/gql';

export const ACCEPT_POP_IN_CLINIC_REQUEST_MUTATION = gql(`
  mutation Staff_AcceptPopInClinicRequest {
    staff_acceptPopInClinicRequest {
      id
      status
      requestType
      patientId
      eventId
    }
  }
`);
